// istanbul ignore file
// TODO: Remove as part of DMD-4864
import { TypographyOptions } from '@mui/material/styles/createTypography';
import merge from 'lodash/merge';
import pick from 'lodash/pick';

import { defaultTypography } from '@/theme/themes/typography';
import { MEDIUM_SOY } from '@/theme/themes/colors';
import {
  TARGET_IDENTIFIERS,
  TYPOGRAPHY_STYLE_ATTRIBUTES
} from '@/brand/constants';

export const getTypography = (transformedBrandStyles: Record<string, any>) => {
  // Add additional typography as needed here and add to the return object
  return {
    ...getBaseTypography(transformedBrandStyles)
  };
};

export const BASE_TYPOGRAPHY = Object.freeze({
  color: MEDIUM_SOY,
  fontWeight: '400'
});

export const getBaseTypography = (
  brandStyles: Record<string, any>
): TypographyOptions => {
  const h1: Record<string, any> = merge(
    {
      fontSize: '46px',
      textTransform: 'uppercase'
    },
    BASE_TYPOGRAPHY,
    pick(brandStyles[TARGET_IDENTIFIERS.H1], TYPOGRAPHY_STYLE_ATTRIBUTES)
  );
  const h2: Record<string, any> = merge(
    {
      fontSize: '26px',
      textTransform: 'uppercase'
    },
    BASE_TYPOGRAPHY,
    pick(brandStyles[TARGET_IDENTIFIERS.H2], TYPOGRAPHY_STYLE_ATTRIBUTES)
  );
  const h3: Record<string, any> = merge(
    {
      fontSize: '16px',
      textTransform: 'uppercase'
    },
    BASE_TYPOGRAPHY,
    pick(brandStyles[TARGET_IDENTIFIERS.H3], TYPOGRAPHY_STYLE_ATTRIBUTES)
  );
  const body1: Record<string, any> = merge(
    {
      fontSize: '16px',
      textTransform: 'none',
      lineHeight: '1.167'
    },
    BASE_TYPOGRAPHY,
    pick(brandStyles[TARGET_IDENTIFIERS.PARAGRAPH], TYPOGRAPHY_STYLE_ATTRIBUTES)
  );
  const button: Record<string, any> = merge(
    {
      textTransform: 'uppercase',
      fontSize: '18px'
    },
    BASE_TYPOGRAPHY,
    pick(
      brandStyles[TARGET_IDENTIFIERS.PRIMARY_BUTTON],
      TYPOGRAPHY_STYLE_ATTRIBUTES
    )
  );

  const typography = {
    h1,
    h2,
    h3,
    body1,
    button,
    fontFamily: h3?.fontFamily
  };

  const result = merge({}, defaultTypography, typography);
  return result;
};
